import React, {useState} from 'react';
import Slider from 'react-slick';
import {getBanner} from '@/store/api/home';
import {host} from '@/utils/hostConf';
import {useAutoQuery} from '@/utils/hooks';
import defaultBanner from '@/assets/images/banner-def.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.less';

function Banner({city_no}) {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
  };

  //请求banner数据
  let {
    data: {list},
  } = useAutoQuery(getBanner, {city_no, platform: 1, hold: !city_no});

  return (
    <div className="banner">
      {list && list.length > 0 ? (
        <Slider {...settings}>
          {list.map((banner) => {
            const url = decodeURI(banner.url).replace(/&amp;/g, '&');
            return (
              <a className="banner-item" href={url} key={banner.img_url}>
                <img className="banner-img" src={`${host.dr_img}${banner.img_url}`} alt="" />
              </a>
            );
          })}
        </Slider>
      ) : (
        <img className="banner-img" src={defaultBanner} alt="" />
      )}
    </div>
  );
}

export default Banner;
